import { useAiChatDiscoveryFabVisibility } from '../ai_chat_discovery_fab_visibility'
import { AI_CHAT_DISCOVERY_VARIANT } from '../constants'
import { useAiChatDiscoveryExperiment } from './use_ai_chat_discovery_experiment'
import { useAiChatDiscoveryMiEligible } from './use_ai_chat_discovery_mi_eligible'
import { useAiChatDiscoveryVariant } from './use_ai_chat_discovery_variant'

const { TOP_BUTTON } = AI_CHAT_DISCOVERY_VARIANT

/**
 * Logs experiment exposure once when an MI-eligible user can see a discovery entry point
 * (left nav, floating FAB, or top/app-bar button). Mount a single instance under the publisher shell.
 */
export const useAiChatDiscoveryExperimentExposure = () => {
  const isMiEligible = useAiChatDiscoveryMiEligible()
  const {
    isVariantResolved,
    showsLeftNavAiLink,
    effectiveVariant,
  } = useAiChatDiscoveryExperiment()
  const { showFab } = useAiChatDiscoveryFabVisibility()

  const shouldLogExposure = isMiEligible
    && isVariantResolved
    && (
      showsLeftNavAiLink
      || showFab
      || effectiveVariant === TOP_BUTTON
    )

  useAiChatDiscoveryVariant(shouldLogExposure)
}
